// extracted by mini-css-extract-plugin
module.exports = {"shareTrigger":"style_shareTrigger__dro_E","shareMenu":"style_shareMenu__6uS_p"};